import EventArgs from './EventArgs';
export default class SimpleEventArgs extends EventArgs {
    constructor(value) {
        super();
        this.value = value;
    }
}
//# sourceMappingURL=SimpleEventArgs.js.map